import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import OnboardingContent from "../components/OnboardingContent";
import { OnboardingMainRouteQuery } from "./__generated__/OnboardingMainRouteQuery.graphql";

const onboardingMainRouteQuery = graphql`
  query OnboardingMainRouteQuery {
    me {
      ...appMe
      organization {
        ...OnboardingContent_organization
      }
    }
  }
`;

export default function OnboardingMainRoute() {
  const data = useLazyLoadQuery<OnboardingMainRouteQuery>(
    onboardingMainRouteQuery,
    {},
    { fetchPolicy: "store-or-network" }
  );

  return <OnboardingContent organization={data.me.organization} />;
}
